import React, { Component, Fragment} from 'react';

import { connect } from 'react-redux';
import './Profile.Module.scss';

import Top from 'components/UI/Top/Top';
import FilterMenu from 'components/UI/FilterMenu/FilterMenu';

/**
 * import components
 */

import loginUser from 'actions/authentication/login';

const mapDispatchToProps = {
    loginUser
};

const mapStateToProps = (state, props) => {
    return {
        authentication: state.authentication
    };
};

class Profile extends Component {

    constructor() {
        super();

        this.state = {
            email: '',
            password: '',
            name: ''
        }

        this.handleFieldChange  = this.handleFieldChange.bind(this);
        this.handleLogin        = this.handleLogin.bind(this);
    }

    componentDidMount(){
        this.setState({
            email: this.props.authentication.user.email,
            name: this.props.authentication.user.name,
        })
    }

    handleFieldChange(event) {
        if(event.target.name == 'email') {
            
            this.setState({email: event.target.value});

        } else if(event.target.name == 'password') {

            this.setState({password: event.target.value});
        } else if(event.target.name == 'name') {

            this.setState({name: event.target.value});
        }
    }

    handleLogin() {
        this.props.loginUser(this.state).then(Result => {

        }).catch((error) => {
            alert(error);
        });
    }

    render() {

        return (
            <Fragment>
                
                <Top></Top>
                <div styleName='pagewrapper'>
                    <FilterMenu display="false"></FilterMenu>
                    <div styleName='wrapper'>
                        <h1>PROFIEL</h1>
                        <h3 style={{fontStyle: 'italic'}}>Pas je profiel aan</h3>
                        
                        <form styleName='form'>
                            <input styleName='input' value={this.state.email} onChange={this.handleFieldChange} name='email' type="text" placeholder="Email" />
                            <input styleName='input' value={this.state.name} onChange={this.handleFieldChange} name='name' type="name" placeholder="Naam" />
                            <input styleName='input' value={this.state.password} onChange={this.handleFieldChange} name='password' type="password" placeholder="Wachtwoord" />
                            <input styleName='input' value={this.state.password} onChange={this.handleFieldChange} name='password' type="password" placeholder="Wachtwoord check" />
                            <div styleName='button-wrapper'>
                                <a href="#" onClick={this.handleLogin} styleName="button" >Aanpassingen opslaan</a>
                                <a href="#" onClick={this.handleLogin} styleName="button logout" >Uitloggen</a>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);